module.exports = __webpack_public_path__ + "static/colors-2cc7eff0951a91e8efd22e3a92998663.png";